const indexItems = [
  { title: '网红塌房全集', count: 386, icon: 'ri-alert-line', color: 'bg-primary-100 text-primary-600' },
  { title: '网曝门专题', count: 274, icon: 'ri-eye-line', color: 'bg-accent-100 text-accent-700' },
  { title: '明星爆料台', count: 219, icon: 'ri-star-line', color: 'bg-primary-100 text-primary-600' },
  { title: '博主反差录', count: 193, icon: 'ri-contrast-2-line', color: 'bg-secondary-100 text-secondary-700' },
  { title: '每日大赛现场', count: 312, icon: 'ri-live-line', color: 'bg-accent-100 text-accent-700' },
  { title: '吃瓜深扒区', count: 157, icon: 'ri-search-eye-line', color: 'bg-primary-100 text-primary-600' },
  { title: '塌房时间线', count: 128, icon: 'ri-timeline-view', color: 'bg-secondary-100 text-secondary-700' },
  { title: '黑料合集库', count: 245, icon: 'ri-folder-2-line', color: 'bg-accent-100 text-accent-700' },
  { title: '吃瓜名场面', count: 198, icon: 'ri-emotion-laugh-line', color: 'bg-primary-100 text-primary-600' },
];

export default function IndexGrid() {
  return (
    <section id="index" className="w-full py-12 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 rounded-full bg-primary-500"></div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-900">
            主题索引
          </h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {indexItems.map((item) => (
            <a
              key={item.title}
              href="#"
              className="flex items-center gap-4 p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300/50 hover:bg-primary-50/30 transition-all duration-200 cursor-pointer group"
            >
              <div className={`w-11 h-11 rounded-lg ${item.color} flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-200`}>
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-800 whitespace-nowrap">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-400 mt-0.5 whitespace-nowrap">
                  {item.count} 条内容
                </p>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-500 transition-colors duration-200 flex-shrink-0"></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}